export default __webpack_public_path__ + "049991d.png";